import { render, staticRenderFns } from "./SkipTut.vue?vue&type=template&id=f4059d1a&"
import script from "./SkipTut.vue?vue&type=script&lang=js&"
export * from "./SkipTut.vue?vue&type=script&lang=js&"
import style0 from "./SkipTut.vue?vue&type=style&index=0&id=f4059d1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports